// extracted by mini-css-extract-plugin
export default {"disabledLink":"disabledLink__PKkvo"};